import { attributesToProps, domToReact } from 'html-react-parser';

const MAX_LENGTHS = { phone: 30, email: 254 };

const ConsultationInput = ({ attr, busy, error, clearError }) => {
  const { value, ...rest } = attr;
  return <><input {...rest} defaultValue="" maxLength={MAX_LENGTHS[attr.name] || 80} required={attr.name !== 'company'} disabled={busy} aria-invalid={!!error} aria-describedby={error ? `${attr.id}-error` : undefined} onInput={clearError} />{error && <p id={`${attr.id}-error`} className="field-error" data-testid={`${attr['data-testid']}-error`}>{error}</p>}</>;
};

export const ConsultationFields = ({ node, busy, errors, setErrors }) => domToReact(node.children, {
  replace(child) {
    if (!child.attribs) return;
    const attr = attributesToProps(child.attribs);
    if (child.name === 'input') {
      const clearError = () => { if (errors[attr.name]) setErrors(current => ({ ...current, [attr.name]: undefined })); };
      return <ConsultationInput attr={attr} busy={busy} error={errors[attr.name]} clearError={clearError} />;
    }
    if (child.name === 'button') return <button {...attr} type="submit" disabled={busy} aria-busy={busy}>{busy ? 'Sending your request…' : 'Request a Consultation'}</button>;
  },
});

export const ConsultationSuccess = ({ receipt, testId, onReset }) => <div className="consultation-notice" role="status" data-testid={`${testId}-success`}>
  <h4 data-testid={`${testId}-success-heading`}>Thank you for reaching out.</h4>
  <p data-testid={`${testId}-success-message`}>{receipt.message}</p>
  <p className="consultation-reference" data-testid={`${testId}-reference`}>Reference: {receipt.id}</p>
  <p data-testid={`${testId}-success-disclaimer`}>Submitting a request does not create an attorney-client relationship or guarantee representation.</p>
  <button type="button" className="consultation-retry" data-testid={`${testId}-new-request`} onClick={onReset}>Send another request</button>
</div>;